<template>
    <div>
        <b-modal id="create-custom-doc-field" title="Create a new custom document Field" scrollable hide-footer>
            <form-resource-edit v-if="customDocFieldResource && !isSaving" :resourceInstance="customDocFieldResource" :fieldSet="formsets.customDocFieldFormSet" ref="createCustomDocFieldEdit" />
            <div v-else>Saving...</div>
            <div class="newUserButtonContainer">
                <b-button @click="closeModal('create-custom-doc-field')">Cancel</b-button>
                <b-button @click="saveNewCustomDocField">Save</b-button>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// resources
import CustomDocFieldResource from '../../resources/custom_doc_field'
// components&views
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import customDocFieldFormSet from '../../resources/formsets/custom_doc_field'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        customeDocId: {
            required: true,
            type: [String, Number],
        },
    },
    data() {
        return {
            customDocFieldResource: null,
            isSaving: false,
        }
    },
    computed: {
        formsets() {
            return {
                customDocFieldFormSet,
            }
        },
    },
    mixins: [modalMixin, toastMixin],
    components: {
        FormResourceEdit,
    },
    methods: {
        // Set defaults
        displayNewCustomDocFieldForm() {
            this.customDocFieldResource.set('status', '1')
            this.customDocFieldResource.set('required', '1')
            this.customDocFieldResource.set('role', 'employee')
            this.customDocFieldResource.set('custom_document_id', this.customeDocId)
        },
        async saveNewCustomDocField() {
            let errors = this.customDocFieldResource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                try {
                    this.isSaving = true
                    const result = await this.customDocFieldResource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        this.createToast('b-toaster-top-center', 'success', true, 'Custom Document FieldCreated', '')
                        this.closeModal('create-custom-doc-field')
                    }
                } catch (error) {
                    // console.log(error)
                    this.createToast('b-toaster-top-center', 'danger', true, 'Custom Document Field Creation Error', '')
                    throw error
                }
                this.isSaving = false
            }
        },
    },
    mounted() {
        this.customDocFieldResource = new CustomDocFieldResource()
        this.displayNewCustomDocFieldForm()
    },
})
</script>
